<mat-stepper [orientation]="orientation" [class.disable-header-buttons]="disableHeaderButtons">
    <ng-template matStepperIcon="edit">
        <mat-icon>{{completedStepIcon}}</mat-icon>
    </ng-template>
      <mat-step [label]="step.label" *ngFor="let step of steps">
        <ng-container *ngTemplateOutlet="step.templateRef"></ng-container>
      </mat-step>
</mat-stepper>